import React, { FC } from "react";

import { classNames } from "repoV2/utils/common/render/classNames";
import { ICTAButtons } from "./CTAButton";

import styles from "../../event.module.scss";
import useCTAButtons from "./useCTAButtons";
import CTAButtonRender from "../CTAButtonRender";

const CTAButtons: FC<ICTAButtons.IProps> = props => {
    const { buttonClassName } = props;

    const {
        showAddtoCartCta,
        showMainCta,
        addToCartText,
        handleAddToCart,
        handleMainBtnClick,
        mainCtaText,
    } = useCTAButtons(props);

    return (
        <>
            <div className={styles.ctaContainer}>
                {showAddtoCartCta && (
                    <CTAButtonRender
                        design="secorndary"
                        className={classNames(
                            buttonClassName,
                            showMainCta ? "w-50 mr-2" : "w-100"
                        )}
                        onClick={handleAddToCart}
                        ctaText={addToCartText}
                    />
                )}

                {showMainCta && (
                    <CTAButtonRender
                        className={classNames(
                            buttonClassName,
                            showAddtoCartCta ? "w-50" : "w-100"
                        )}
                        onClick={handleMainBtnClick}
                        showArrow={!showAddtoCartCta}
                        ctaText={mainCtaText}
                    />
                )}
            </div>
            {/**
             * TODO @mayank: delete if not used by 1st July 2023
            <div className={styles.backdropCover} /> 
             */}
        </>
    );
};

export default CTAButtons;
